import styled from 'styled-components';
import { Tabs } from 'antd';

export const PageContainer = styled.div`
  min-height: 100vh;
  background: #f0f2f5;
`;

export const TabNavigation = styled.div`
  background: #ffffff;
  padding: 0;
  margin: 0;
  border-bottom: 2px solid #e8e8e8;
  position: sticky;
  top: 64px;
  z-index: 100;
  box-shadow: 
    0 4px 12px rgba(0, 0, 0, 0.08),
    0 2px 4px rgba(0, 0, 0, 0.04);
`;

export const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin: 0;
    padding: 0 24px;
    background: #ffffff;
  }

  .ant-tabs-tab {
    color: #595959 !important;
    font-weight: 500;
    font-size: 15px;
    padding: 20px 32px;
    margin: 0 4px;
    border: none !important;
    border-radius: 12px 12px 0 0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;

    &:hover {
      color: #1890ff !important;
      background: rgba(24, 144, 255, 0.1);
      transform: translateY(-2px);
    }

    &.ant-tabs-tab-active {
      color: #1890ff !important;
      background: rgba(24, 144, 255, 0.08) !important;

      .ant-tabs-tab-btn {
        color: #1890ff !important;
        font-weight: 700;
        font-size: 16px;
      }
    }
  }

  .ant-tabs-ink-bar {
    background: #1890ff;
    height: 4px;
    border-radius: 4px 4px 0 0;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.4);
  }

  .ant-tabs-content-holder {
    padding: 24px;
    background: #fafafa;
    min-height: calc(100vh - 200px);
    height: auto;
    overflow: visible;
  }
`;

export const ContentWrapper = styled.div`
  margin: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: visible;
`;

